import React, { Component } from 'react'
import logo from "../abc.png";
import axios from "axios";
import Path from "./config";
export class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {
            phoneId: null,
            userId: null,
            sbg_first_name: '',
            sbg_payment_status: ''

        }
    }

    componentDidMount() {

        this.setState({
            userId: localStorage.getItem("userId")
        })
        this.setState({
            phoneId: localStorage.getItem("phoneId")
        })

        if (!localStorage.getItem("userId")) {
            this.props.parentProps.history.push('/');
        }

        axios.get(Path + 'Suchi_bride_groom_show_status.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                response = response.data;
                localStorage.setItem('bookstatus', response.sbg_payment_status);
                // console.log(response)
                this.setState({
                    sbg_approved_status: response.sbg_office_appoved_status,
                    sbg_first_name: response.sbg_first_name,
                    sbg_admin_approved_status: response.sbg_admin_approved_status,
                    sbg_edu: response.sbg_edu,
                    sbg_income: response.sbg_income,
                    sbg_family: response.sbg_family,
                    sbg_relative: response.sbg_relative,
                    sbg_asset: response.sbg_asset,
                    sbg_upload: response.sbg_upload,
                    sbg_post_address: response.sbg_post_address,
                    sbg_summery: response.sbg_summery,
                    sbg_payment_status: response.sbg_payment_status
                })
            }.bind(this))


    }

    logouti = () => {
        // alert("logout");
        localStorage.removeItem('userId');
        localStorage.removeItem('phoneId');

        this.props.parentProps.history.push('/');
    }
    render() {
        let status = "";
        if (this.state.sbg_approved_status === "0") {
            status = <span className="text-danger  font-weight-bold">  SAP </span>
        }
        else if (this.state.sbg_approved_status === "1") {
            status = <span className="text-success  font-weight-bold">  SAC </span>
        }

        let adminStatus = "";
        if (this.state.sbg_admin_approved_status === "0") {
            adminStatus = <span className="text-danger font-weight-bold">   AP </span>
        }
        else if (this.state.sbg_admin_approved_status === "1") {
            adminStatus = <span className="text-success  font-weight-bold">    AC </span>
        }

        let infoStatus = "";
        if (
            this.state.sbg_summery === "1") {
            infoStatus = <span className="text-success  font-weight-bold">  IC </span>
        }
        else {
            infoStatus = <span className="text-danger  font-weight-bold">  II</span>
        }

        return (
            <>

                {/* <nav class=" navbar navbar-expand-lg navbar-dark bg-danger">
            <div class=" justify-content-md-center my-2">
                <img src={logo} alt="Logo" className="img-fluid" style={{width:"100px"}} />
                <a class="navbar-brand" >LEVA SHUBHMANGAL</a>
            
            </div>
            <div class="nav justify-content-end mr-5 text-light">
               Welcome !! {this.state.phoneId} 
            </div>
            </nav> */}

                <nav className="navbar navbar-light bg-danger">
                    <div className="container-fluid text-light">
                        <img src={logo} alt="Logo" style={{ width: "170px" }} />
                        {/* Information Status : {infoStatus} &nbsp; &nbsp;||  &nbsp; &nbsp;
                   Submit Status : {status}  &nbsp; &nbsp; || &nbsp; &nbsp;
                   Admin Status : {adminStatus} */}
                        <form className="d-flex">
                            Welcome {this.state.sbg_first_name} !! {this.state.phoneId}  &nbsp;&nbsp;&nbsp;
                            <button type="button" className="btn-primary text-light" onClick={() => this.logouti()} >Logout</button>
                        </form>
                    </div>

                </nav>
                <div className="bg-warning">
                    <div className="container-fluid text-dark text-center p-2">
                        {/* <img src={logo} alt="Logo"  style={{width:"200px"}} /> */}
                        Information Status :{infoStatus} &nbsp; &nbsp;||  &nbsp; &nbsp;
                        Submit Status :  {status}  &nbsp; &nbsp; || &nbsp; &nbsp;
                        Admin Status : {adminStatus}
                        {/* <form className="d-flex">
                    Welcome {this.state.sbg_first_name} !! {this.state.phoneId}  &nbsp;&nbsp;&nbsp;
                    <button type="button" className="btn-primary text-light" onClick={()=>this.logouti()} >Logout</button>
                    </form> */}
                    </div>
                </div>





            </>
        )
    }
}

export default Header
